import React from 'react';

import { useTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router';

import { IconButton, Button, Tabs } from 'components';
import { PdvInfo } from './PdvInfo';
import { Logs } from './Logs';

import { resolvePath, routePaths } from 'constants/routes';
import * as Styles from 'styles/Details';
import { Flex } from 'styles/Flex';

export function DetailPDV(props: RouteComponentProps<{ id: string }>) {
  const { t } = useTranslation('pages/details');

  const pdvId = props.match.params.id;

  return (
    <Styles.Container>
      <Flex alignItems="center" wrap gap={1} justifyContent="space-between">
        <Flex alignItems="center" gap={1}>
          <IconButton
            icon={{ name: 'arrowBack', size: 1.4 }}
            onClick={() => props.history.goBack()}
          />
          <h1 style={{ margin: 0 }}>{t('pdv.title')}</h1>
        </Flex>
        <Button onClick={() => props.history.push(resolvePath(routePaths.pdv.edit, { id: pdvId }))}>
          {t('pages/details:editButton')}
        </Button>
      </Flex>
      <Styles.Wrapper>
        <Tabs tabs={[{ label: 'Dados do PDV' }, { label: 'Log de alteração' }]}>
          <PdvInfo id={pdvId} />
          <Logs id={pdvId} />
        </Tabs>
      </Styles.Wrapper>
    </Styles.Container>
  );
}
